import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { WPService } from 'src/app/core/http/web/wp.service';
import { environment as params, environment } from 'src/environments/environment';
import { HuespedesComponent } from '../inputs/huespedes/huespedes.component';
import { DatepickerComponent } from '../inputs/datepicker/datepicker.component';
import { saveDataSearchUtil } from 'src/app/core/services/utilities/saveDataSearchUtil.service';
import { PtDestFlightComponent } from './components/pt-dest-flight/pt-dest-flight.component';
import { PtDestBusComponent } from './components/pt-dest-bus/pt-dest-bus.component';
import { ReadJSONService } from 'src/app/modules/motores/seguros/services/read-json.service';
import { WidgetService } from 'src/app/core/http/web/widget.service';

@Component({
  selector: 'app-flight-and-hotel',
  templateUrl: './flight-and-hotel.component.html',
  styleUrls: ['./flight-and-hotel.component.scss']
})
export class FlightAndHotelComponent {
  urlBaseMJ: any = (<any>params).api.mj;
  public form: FormGroup;
  public passengersShow: any = false;
  public destBus: any;
  public type: string = 'VUELO';
  public submited: boolean;
  public priceTravel: any;
  public priceTravelOrigin:any;
  public priceTravelBus: any;
  public priceTravelBusOrigin:any;
  private savedDate:any;
  @Input() public widgetData: any = null;

  @ViewChild('sig') airportsCompo: PtDestFlightComponent;
  @ViewChild('sig2') airportsCompo2: PtDestFlightComponent;
  @ViewChild('sigbus') destBusCompo: PtDestBusComponent;
  @ViewChild('sigbus2') destBusCompo2: PtDestBusComponent;
  @ViewChild('picker1') datePicker: DatepickerComponent;
  @ViewChild('picker2') datePicker2: DatepickerComponent;
  @ViewChild('huespedes1') huespedes: HuespedesComponent;
  @ViewChild('huespedes2') huespedes2: HuespedesComponent;

  constructor(
    private _f: FormBuilder,
    private wpServ: WPService,
    private saveInfoServ: saveDataSearchUtil,
    private readJson: ReadJSONService
  ) {
    this.getDestinations();
    this.getOrigin();
    this.getBusDestinations();
    this.getBusOrigin();
    this.buildForm();
    this.getDestBus();
  }

  buildForm() {
    this.form = this._f.group({
      date: ['', [Validators.required]],
      fOrigen: ['', [Validators.required]],
      fDestino: ['', [Validators.required]],
      fPasajeros: ['', [Validators.required]]
    });

    this.form.get('fOrigen').valueChanges.subscribe(value => {
      if (typeof value === 'object') {
        if (this.type == 'BUS') {
          this.saveInfoSearchVH('origen_bus', value.display + ' (' + value.id + ')');
          // this.saveInfoSearchFy('Origen Bus', );
          if (document.documentElement.clientWidth < 992) {
            if (this.destBusCompo2) {
              this.destBusCompo2.checkFocus();
            }
          } else {
            if (this.destBusCompo) {
              this.destBusCompo.checkFocus();
            }
          }
        } else {
          this.saveInfoSearchVH('origen_vuelo', value.name + ' (' + value.iata + ')');
          if (document.documentElement.clientWidth < 992) {
            if (this.airportsCompo2) {
              this.airportsCompo2.checkFocus();
            }
          } else {
            if (this.airportsCompo) {
              this.airportsCompo.checkFocus();
            }
          }
        }
      }

    });

    this.form.get('fDestino').valueChanges.subscribe(value => {
      if (typeof value == 'object') {
        if (document.documentElement.clientWidth < 992) {
          this.datePicker2.openDatepicker();
        } else {
          this.datePicker.openDatepicker();
        }
        if (this.type == 'BUS') {
          this.saveInfoSearchVH('destino_bus', value.display + ' (' + value.id + ')');
        } else {
          this.saveInfoSearchVH('destino_vuelo', value.name + ' (' + value.iata + ')');
        }
      }
    });
    this.form.get('date').valueChanges.subscribe(value => {
      console.log("DATE CHANGES: ", value);
      
      if (value.length == 2) {
        this.saveInfoSearchVH('fecha_ida', value[0]);
        this.saveInfoSearchVH('fecha_vuelta', value[1]);
        setTimeout(() => {
          if (document.documentElement.clientWidth < 992) {
            this.huespedes2.menu.openMenu();
          } else {
            this.huespedes.menu.openMenu();
          }
        }, 1000);
      }
    });
  }
  getDestBus() {
    this.wpServ.getDestBus().subscribe(data => {
      this.destBus = data;
    });
  }

  updateFormHuespedes(data) {
    this.form.controls.fPasajeros.setValue(data);
  }

  enviar() {
    this.submited = true;
    let data = this.form.value;

    this.savedDate = data.date.length>0?data.date:this.savedDate;
    data.date = this.savedDate;

    this.form.get('date').setValue(data.date);

    if (this.form.value.fPasajeros != '') {
      this.saveInfoSearchVH('habitaciones', JSON.stringify(this.form.value.fPasajeros));
    }
    console.log('Vuelos+Hotel-enviar: ', data, this.form);
    if (this.form.invalid) {
      return;
    }
    let URL = this.buildURL(data);
    console.log('Construir URL: ', URL);
    // URL = `https://paqnacionales.mundojoven.com/paquetes?CheckIn=2019%2F10%2F24&CheckOut=2019%2F10%2F27&Rooms=1&room0.Adults=2&room0.Kids=2&CustomAirportCode=MEX&MappingId=26&MappingType=2&room0.AgeKids=9%2C10&IsQuote=true&returnAirportCode=CUN`;
    window.open(URL.trim(), '_blank');

  }

  saveInfoSearchVH(key, value) {
    this.saveInfoServ.saveData('Widget vuelo+hotel', key, value);
  }

  changeType(value) {
    this.type = value;
    console.log('Cambiando tipo: ', value);
  }

  buildURL(data) {
    let baseURL = '';


    // CheckIn=2019/10/24
    // &CheckOut=2019/10/27
    // &Rooms=1
    // &room0.Adults=2
    // &room0.Kids=2
    // &CustomAirportCode=MEX
    // &MappingId=26
    // &MappingType=2
    // &room0.AgeKids=9,10
    // &IsQuote=true
    // &returnAirportCode=CUN


    if (this.type == 'VUELO') {

      baseURL = 'https://paqnacionales.mundojoven.com/paquetes?';
      console.log("DATOS: ", data.fOrigen, data.fDestino);

      baseURL = baseURL.concat(
        '&CheckIn=',encodeURIComponent(
          data.date[0].split('-').reverse().join('/')
        )
      );
      baseURL = baseURL.concat(
        '&CheckOut=',encodeURIComponent(
          data.date[1].split('-').reverse().join('/')
        )
      );
      baseURL = baseURL.concat('&Rooms=', data.fPasajeros.fHab.length);
      data.fPasajeros.fHab.map((h, i) => {
        baseURL = baseURL.concat(`&room${i}.Adults=`, h.fAdults); //Dinámico con habitaciones
        baseURL = baseURL.concat(`&room${i}.Kids=`, h.fChilds); //Dinámico con habitaciones
        baseURL = baseURL.concat(`&room${i}.AgeKids=`); //Dinámico con edaeds
        h.fEdades.map((e, j) => {
          baseURL = baseURL.concat(e.fEdad); //Dinámico con habitaciones
          if((j+1)!=h.fEdades.length){
            baseURL = baseURL.concat(','); //Dinámico con habitaciones
          }
        });
      });
      baseURL = baseURL.concat('&CustomAirportCode=', data.fOrigen.AirportCode);
      // baseURL = baseURL.concat('&returnAirportCode=', data.fDestino.iata);
      baseURL = baseURL.concat(
        '&MappingId=',data.fDestino.MappingId
      );
      baseURL = baseURL.concat(
        '&MappingType=2'
      );
      baseURL = baseURL.concat('&IsQuote=true');
    } else {
      //Autobus
      baseURL = 'https://paqnacionales.mundojoven.com/QuoteFromCustomWidget?';

      //buses.ListRequest.DepartureOfficeId=51
      // &buses.ListRequest.ArrivalOfficeId=417
      // &BesttxtCheckinPck=03/10/2019
      // &BesttxtCheckoutPck=07/10/2019
      // &num_cuartos=2
      // &num_adultos_1=2
      // &IsPackage=true
      // &tipo_paquete=1
      baseURL = baseURL.concat(
        '&buses.ListRequest.DepartureOfficeId=', data.fOrigen.id
      );
      baseURL = baseURL.concat(
        '&buses.ListRequest.ArrivalOfficeId=', data.fDestino.id
      );
      baseURL = baseURL.concat(
        '&BesttxtCheckinPck=',
        data.date[0].split('-').join('/')
      );
      baseURL = baseURL.concat(
        '&BesttxtCheckoutPck=',
        data.date[1].split('-').join('/')
      );
      baseURL = baseURL.concat('&num_cuartos=', data.fPasajeros.fHab.length);
      data.fPasajeros.fHab.map((h, i) => {
        baseURL = baseURL.concat(`&num_adultos_${i + 1}=`, h.fAdults); //Dinámico con habitaciones
        baseURL = baseURL.concat(`&num_ninos_${i + 1}=`, h.fChilds); //Dinámico con habitaciones
        h.fEdades.map((e, j) => {
          baseURL = baseURL.concat(`&EdadNino${j + 1}_${i + 1}=`, e.fEdad); //Dinámico con habitaciones
        });
      });
      baseURL = baseURL.concat('&IsPackage=true', '&tipo_paquete=1');
    }
    return baseURL;
  }
  reverse() {
    let temp = JSON.parse(JSON.stringify(this.form.controls.fOrigen.value));
    console.log(
      'TEMP:',
      temp,
      this.form.controls.fDestino.value,
      this.form.controls.fOrigen.value
    );

    this.form.controls.fOrigen.setValue(this.form.controls.fDestino.value);
    this.form.controls.fDestino.setValue(temp);
  }






  /********************* Servicios price travel *********************/
  getOrigin() {
    this.wpServ.getPriceTravel('0sf8ez365j') .subscribe(
      data => {
        // this.airportsGrp = data.data;
        console.log("Destinos: ", data);
        let priceTravel = data.data;
        this.priceTravelOrigin = [];
          const map = new Map();
          for (const item of priceTravel) {
              if(!map.has(item.AirportId)){
                  map.set(item.AirportId, true);
                  this.priceTravelOrigin.push({
                    "AirportId": item.AirportId,
                    "AirportCode": item.AirportCode,
                    "AirportCity": item.AirportCity,
                    "NormalizedName": item.NormalizedName,
                    "Restrictions": item.Restrictions
                  });
              }
          }
      }, (err) => {
      console.error('Error :', err);
    });
  }
  getDestinations() {
    this.wpServ.getPriceTravel('yv92el9kxy') .subscribe(
      data => {
        // this.airportsGrp = data.data;
        console.log("Destinos destinations: ", data);
        let priceTravel = data.data;
        priceTravel = priceTravel.filter(f=>{
          return f.MappingType==2
        });
        this.priceTravel = [];
          const map = new Map();
          for (const item of priceTravel) {
              if(!map.has(item.MappingId)){
                  map.set(item.MappingId, true);
                  this.priceTravel.push({
                    AirportCode: item.AirportCode,
                    MappingId: item.MappingId,
                    MappingType: item.MappingType,
                    Name: item.Name,
                    Restrictions: item.Restrictions,
                    display: item.display,
                    label: item.label,
                  });
              }
          }
      }, (err) => {
      console.error('Error :', err);
    });
  }
  getBusOrigin() {
    this.wpServ.getPriceTravel('kzody4a9hi') .subscribe(
      data => {
        // this.airportsGrp = data.data;
        console.log("Destinos bus origin: ", data);
        let priceTravel = data.data;
        this.priceTravelBusOrigin = [];
          const map = new Map();
          for (const item of priceTravel) {
              if(!map.has(item.id)){
                  map.set(item.id, true);
                  this.priceTravelBusOrigin.push({
                    id: item.id,
                    display: item.display,
                    search: item.search
                  });
              }
          }
      }, (err) => {
      console.error('Error :', err);
    });
  }
  getBusDestinations() {
    this.wpServ.getPriceTravel('46e3bptsfk') .subscribe(
      data => {
        // this.airportsGrp = data.data;
        console.log("Destinos bus: ", data);
        let priceTravel = data.data;
        this.priceTravelBus = [];
          const map = new Map();
          for (const item of priceTravel) {
              if(!map.has(item.id)){
                  map.set(item.id, true);
                  this.priceTravelBus.push({
                    id: item.id,
                    name: item.name
                  });
              }
          }
      }, (err) => {
      console.error('Error :', err);
    });
  }
}
